module.exports = __webpack_public_path__ + "img/Speaker=Jamie Quint.5c96c031.png";